import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { getContent } from '../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';
import ActionType from '../../redux/reducer/globalActionType';
import IconTicketWhatsapp from '../../assets/icons/IconTicketWhatsapp';
import IconTicketPhone from '../../assets/icons/IconTicketPhone';
import IconTicketEmail from '../../assets/icons/IconTicketEmail';
import IconTicketGrochat from '../../assets/icons/IconTicketGrochat';
import TableNexcare from '../../components/Table/TableNexcare';
import IconUpdate from '../../assets/icons/IconUpdate';
import FilterDashboard from '../../components/Filter/FilterDashboard';
import TicketBoxListAll from '../../components/Dashboard/TicketBoxListAll';
import TicketEscalationList from '../../components/Dashboard/TicketEscalationList';
import TicketBoxListSolution from '../../components/Dashboard/TicketBoxListSolution';
import TicketOverviewChart from '../../components/Dashboard/TicketOverviewChart';
import TicketCompletionChart from '../../components/Dashboard/TicketCompletionChart';
import API_DASHBOARD from '../../api/apiDashboard';
import API_NOTIFICATION from '../../api/apiNotification';
import API_CONTACT from '../../api/apiContact';
import ButtonDarkBlue from '../../components/Button/ButtonDarkBlue';
import DashboardWarningAlert from '../../components/Dashboard/DashboardWarningAlert';

const columnsCompletionDetail = [
    {
        title: "Nama CS",
        dataIndex: "cs",
        headerAlign: "justify-start",
        bodyAlign: "text-left",
        width: "w-1/4",
        render: (data) => `${data}`,
    },
    {
        title: "Jumlah Tiket",
        dataIndex: "total_tickets",
        headerAlign: "justify-start",
        bodyAlign: "text-left",
        render: (data) => `${data}`,
    },
    {
        title: "0 Hari",
        dataIndex: "zero_day",
        headerAlign: "justify-start",
        bodyAlign: "text-left",
        render: (data) => `${data}`,
    },
    {
        title: "1 Hari",
        dataIndex: "one_day",
        headerAlign: "justify-start",
        bodyAlign: "text-left",
        render: (data) => `${data}`,
    },
    {
        title: "2 Hari",
        dataIndex: "two_days",
        headerAlign: "justify-start",
        bodyAlign: "text-left",
        render: (data) => `${data}`,
    },
    {
        title: "> 2 Hari",
        dataIndex: "more_than_two_days",
        headerAlign: "justify-start",
        bodyAlign: "text-left",
        render: (data) => `${data}`,
    },
];

class DashboardLead extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            userCategory: '',
            listCustomerServiceData: [],
            listCustomerServiceId: [],
            month: moment().month() + 1,
            year: moment().year(),
            ticketBoxAll: [],
            ticketBoxData: [],
            ticketBoxModalData: {},
            totalOnline: [],
            escalationData: [],
            completionData: [],
            completionDataDetail: [],
            ticketOverviewData: [],
            ticketOverviewDataDetail: {},
            titleTicketBox: '',
            showPopupTicketBox: false,
            showPopupCsOnline: false,
            showPopupTicketByResolution: false,
            showDashboardWarningAlert: false,
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            filter: {
                field: '',
                ascending: false,
                descending: false,
            }
        }
    }

    getDataDashboard = userCategory => {
        let localData = JSON.parse(localStorage.getItem('dashboardLead'));
        let localDataMonth = localData?.month ? localData.month : moment().month() + 1;
        let localDataYear = localData?.year ? localData.year : moment().year();
        localData = localData?.dashboardData;

        if (localData) {
            let rawDataTicket = localData.ticket_dashboard ? localData.ticket_dashboard : [];
            let rawDataEscalation = localData.ticket_escalation ? localData.ticket_escalation : [];
            let rawDataCompletionDetail = localData.ticket_completion_detail ? localData.ticket_completion_detail : [];
            this.setState({
                showDashboardWarningAlert: true,
                month: localDataMonth,
                year: localDataYear,
                ticketBoxData: rawDataTicket,
                ticketBoxAll: rawDataTicket,
                completionDataDetail: rawDataCompletionDetail,
                escalationData: rawDataEscalation,
                ticketOverviewDataDetail: {
                    ...this.state.ticketOverviewDataDetail,
                    totalClosedTicket: rawDataTicket.filter(
                        item => item.status === STATUS_TICKET_CONSTANT.CLOSED
                            || item.status === STATUS_TICKET_CONSTANT.RESOLVED
                            || item.status === STATUS_TICKET_CONSTANT.UNDER_OBSERVATION
                    ).length,
                    averageResolutionTime: localData.average_resolution_time.total_resolution_time_average,
                    averageResolutionTimeAll: localData.average_resolution_time,
                    slaResolutionTime: localData.resolution_sla.total_sla,
                    slaResolutionTimeAll: localData.resolution_sla,
                    averageResponseTime: localData.average_response_time.total_response_time_average,
                    averageResponseTimeAll: localData.average_response_time,
                },
            })

            // Completion
            let data = [
                { name: "0 Hari", value: localData.ticket_completion.zero_day },
                { name: "1 Hari", value: localData.ticket_completion.one_day },
                { name: "2 Hari", value: localData.ticket_completion.two_days },
                { name: "> 2 Hari", value: localData.ticket_completion.more_than_two_days },
            ];
            data.filter(item => item.value > 0).map(item => {
                return this.setState({
                    completionData: [...this.state.completionData, item]
                })
            })
            return;
        }

        return API_DASHBOARD.getDataDashboard(userCategory, this.state.month, this.state.year, this.state.listCustomerServiceId, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let dashboardLead = {
                        dashboardData: getContent(res),
                        listCustomerServiceId: this.state.listCustomerServiceId,
                        month: this.state.month,
                        year: this.state.year
                    }
                    localStorage.setItem('dashboardLead', JSON.stringify(dashboardLead));
                    let rawDataTicket = getContent(res).ticket_dashboard ? getContent(res).ticket_dashboard : [];
                    let rawDataEscalation = getContent(res).ticket_escalation ? getContent(res).ticket_escalation : [];
                    let rawDataCompletionDetail = getContent(res).ticket_completion_detail ? getContent(res).ticket_completion_detail : [];
                    this.setState({
                        showDashboardWarningAlert: false,
                        ticketBoxData: rawDataTicket,
                        ticketBoxAll: rawDataTicket,
                        completionDataDetail: rawDataCompletionDetail,
                        escalationData: rawDataEscalation,
                        ticketOverviewDataDetail: {
                            ...this.state.ticketOverviewDataDetail,
                            totalClosedTicket: rawDataTicket.filter(
                                item => item.status === STATUS_TICKET_CONSTANT.CLOSED
                                    || item.status === STATUS_TICKET_CONSTANT.RESOLVED
                                    || item.status === STATUS_TICKET_CONSTANT.UNDER_OBSERVATION
                            ).length,
                            averageResolutionTime: getContent(res).average_resolution_time.total_resolution_time_average,
                            averageResolutionTimeAll: getContent(res).average_resolution_time,
                            slaResolutionTime: getContent(res).resolution_sla.total_sla,
                            slaResolutionTimeAll: getContent(res).resolution_sla,
                            averageResponseTime: getContent(res).average_response_time.total_response_time_average,
                            averageResponseTimeAll: getContent(res).average_response_time,
                        },
                    })

                    // Completion
                    let data = [
                        { name: "0 Hari", value: getContent(res).ticket_completion.zero_day },
                        { name: "1 Hari", value: getContent(res).ticket_completion.one_day },
                        { name: "2 Hari", value: getContent(res).ticket_completion.two_days },
                        { name: "> 2 Hari", value: getContent(res).ticket_completion.more_than_two_days },
                    ];
                    data.filter(item => item.value > 0).map(item => {
                        return this.setState({
                            completionData: [...this.state.completionData, item]
                        })
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            });
    }

    getInitiateData = () => {
        if (this._isMounted) {
            localStorage.removeItem('dashboardLead');
            this.setState({
                ticketOverviewData: [],
                completionData: [],
                trendVolumeTicketData: [],
                trendVolumeTicketDataPrincipal: [],
            });
            this.checkUserCategory();
        }
    }

    getListCustomerService = () => {
        return API_CONTACT.getListCustomerServiceMember(1, 100, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        listCustomerServiceData: getContent(res).map(item => {
                            return {
                                value: item.user_nexcare_id,
                                label: item.name
                            }
                        })
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getOnlineCS = userCategory => {
        let filter = 'only_member=true';
        return API_DASHBOARD.getTotalOnline(userCategory, filter, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        totalOnline: getContent(res),
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getTicketOverviewData = () => {
        return API_NOTIFICATION.getServerTime(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let time = new Date(getContent(res));
                    let formatTime = moment(time).format("YYYY-MM");
                    let numberOfDaysInMonth = moment(formatTime, "YYYY-MM").daysInMonth();
                    for (let day = 1; day <= numberOfDaysInMonth; day++) {
                        let ticketOverviewData = {
                            name: day,
                            ticket: this.state.ticketBoxData.filter(ticket => {
                                const ticketDay = ticket.created_at.split('T')[0];
                                return parseInt(moment(ticketDay).format('DD')) === day;
                            }).length,
                        };
                        this.setState({ ticketOverviewData: [...this.state.ticketOverviewData, ticketOverviewData] });
                    }
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handlePopupTicketBox = (status, ticketBoxModalData) => {
        this.setState({
            titleTicketBox: status,
            showPopupTicketBox: true,
            ticketBoxModalData
        })
    }

    handlePopupCsOnline = () => {
        this.setState({
            showPopupCsOnline: true
        })
    }

    handlePopupTicketOverview = e => {
        if (e.activePayload[0].payload.ticket > 0) {
            let filterData = this.state.ticketBoxAll.filter(item => parseInt(moment(item.created_at.split('T')[0]).format('D')) === e.activeLabel);
            let averageResolutionTime = this.state.ticketOverviewDataDetail.averageResolutionTimeAll?.ticket_resolutions?.find(item => parseInt(moment(item.date).format('D')) === e.activeLabel);
            let slaResolutionTime = this.state.ticketOverviewDataDetail.slaResolutionTimeAll?.list_sla?.find(item => parseInt(moment(item.date).format('D')) === e.activeLabel);
            let averageResponseTime = this.state.ticketOverviewDataDetail.averageResponseTimeAll?.ticket_responses?.find(item => parseInt(moment(item.date).format('D')) === e.activeLabel);
            this.setState({
                ticketBoxData: [...filterData],
                ticketOverviewDataDetail: {
                    ...this.state.ticketOverviewDataDetail,
                    averageResolutionTime: averageResolutionTime ? averageResolutionTime.resolution_time_average : 0,
                    slaResolutionTime: slaResolutionTime ? slaResolutionTime.resolution_sla : 0,
                    averageResponseTime: averageResponseTime ? averageResponseTime.response_time_average : 0,
                }
            }, () => {
                let totalClosedTicket = this.state.ticketBoxData.filter(item => item.status === STATUS_TICKET_CONSTANT.CLOSED || item.status === STATUS_TICKET_CONSTANT.RESOLVED || item.status === STATUS_TICKET_CONSTANT.UNDER_OBSERVATION).length;
                this.setState({
                    ticketOverviewDataDetail: {
                        ...this.state.ticketOverviewDataDetail,
                        totalClosedTicket: totalClosedTicket,
                    }
                })
            })
            return;
        }
        alert('Tidak ada data!');
    }

    handlePopupTicketResolution = e => {
        this.setState({ showPopupTicketByResolution: true })
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },

            () => {
                console.log(this.state.pagination, "Hit API get data table");
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },

            () => {
                console.log(this.state.pagination, "Hit API get data table");
            }
        );
    }

    handleSorter = sorter => {
        this.setState(
            {
                filter: sorter
            },

            () => {
                console.log(this.state.filter, "Hit API get data table");
            }
        );
    }

    handleFilter = (id, month, year) => {
        if (this.state.loading) return;
        let csId = id.map(item => {
            return item['data_id']
        });
        let listCustomerServiceId = csId.toString();
        this.setState({ listCustomerServiceId, month, year }, () => {
            this.getInitiateData();
        })
    }

    handleResetFilter = () => {
        this.setState({ listCustomerServiceId: '', month: moment().month() + 1, year: moment().year() })
    }

    handleRefresh = () => {
        if (this.state.loading) return;
        this.getInitiateData();
    }

    checkUserCategory = async () => {
        await this.setState({ loading: true })
        await this.fetchDataLead('lead');
        this.setState({ loading: false, userCategory: 'lead' });
    }

    fetchDataLead = async userCategory => {
        await this.getDataDashboard(userCategory);
        await this.getListCustomerService();
        await this.getOnlineCS(userCategory);
        await this.getTicketOverviewData();
        this.setState({ loading: false });
    }

    ticketBoxModalDataComponent = () => {
        const data = this.state.ticketBoxModalData;
        if (data.status === 'all') {
            return (
                <div className="w-full px-5 space-y-3">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center w-1/2">
                            <div className="flex justify-center -ml-3 w-1/4"><IconTicketWhatsapp /></div>
                            <p className="w-3/4">Whatsapp</p>
                        </div>
                        <div>{this.state.ticketBoxModalData.whatsapp}</div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div className="flex items-center w-1/2">
                            <div className="flex justify-center -ml-3 w-1/4"><IconTicketPhone /></div>
                            <p className="w-3/4">Telepon</p>
                        </div>
                        <div>{this.state.ticketBoxModalData.phone}</div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div className="flex items-center w-1/2">
                            <div className="flex justify-center -ml-3 w-1/4"><IconTicketEmail /></div>
                            <p className="w-3/4">Email</p>
                        </div>
                        <div>{this.state.ticketBoxModalData.email}</div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div className="flex items-center w-1/2">
                            <div className="flex justify-center -ml-3 w-1/4"><IconTicketGrochat /></div>
                            <p className="w-3/4 text-nexcarepurple2 font-medium">Chat</p>
                        </div>
                        <div>{this.state.ticketBoxModalData.grochat}</div>
                    </div>
                </div>
            )
        }
        if (data.length > 0) {
            return data.map((data, idx) =>
                data.status === 'unassign'
                    ? <div className={`flex items-center justify-between w-1/2 pb-2 ${idx % 2 === 0 ? 'pr-3' : 'pl-3 pr-1'}`} key={idx}>
                        <p className="whitespace-nowrap cursor-pointer" onClick={() => this.handleRedirectTicketBox(data)}>{data.ticket_no}</p>
                    </div>
                    :
                    <div className={`flex items-center justify-between w-1/2 pb-2 ${idx % 2 === 0 ? 'pr-3' : 'pl-3 pr-1'}`} key={idx}>
                        <p className="whitespace-nowrap w-40 truncate cursor-pointer" title={data.cs} onClick={() => this.handleRedirectTicketBox(data)}>{data.cs}</p>
                        <p>{data.ticket_no.length}</p>
                    </div>
            )
        }
        return (
            <div className="flex justify-center items-center w-full h-40">
                <p>Tidak ada data</p>
            </div>
        )
    }

    handleRedirectTicketBox = data => {
        if (data.status === STATUS_TICKET_CONSTANT.ASSIGNED || data.status === STATUS_TICKET_CONSTANT.IN_PROGRESS || data.status === STATUS_TICKET_CONSTANT.ON_HOLD) {
            return this.props.history.push(`${ROUTER_CONSTANT.TICKET_LIST_ALL}?customerService=${data.assignee_id}&status=${data.status}${this.handleDateRangeTicket()}`);
        }
        if (data.status === STATUS_TICKET_CONSTANT.RESOLVED || data.status === STATUS_TICKET_CONSTANT.CLOSED || data.status === STATUS_TICKET_CONSTANT.UNDER_OBSERVATION) {
            return this.props.history.push(`${ROUTER_CONSTANT.TICKET_LIST_SOLUTION}?customerService=${data.assignee_id}&status=${data.status}${this.handleDateRangeTicket()}`);
        }
        return this.props.history.push(`${ROUTER_CONSTANT.TICKET_DETAIL_ALL.split(':')[0]}${data.id}`);
    }

    handleDateRangeTicket = () => {
        const month = this.state.month < 10 ? '0' + this.state.month : this.state.month;
        const year = this.state.year;
        const date = `&startDate=${year}-${month}-01&endDate=${year}-${month}-${this.getDaysInMonth(year, month)}`;
        return date;
    }

    getDaysInMonth(year, month) {
        const date = new Date(year, month - 1, 1);
        date.setMonth(date.getMonth() + 1);
        date.setDate(date.getDate() - 1);
        return date.getDate();
    }

    componentDidMount() {
        this._isMounted = true;

        this.checkUserCategory();

        let localData = JSON.parse(localStorage.getItem('dashboardLead'));
        if (localData?.listCustomerServiceId) {
            this.setState({
                listCustomerServiceId: localData.listCustomerServiceId,
            })
        }
        if (localData?.month || localData?.year) {
            this.setState({
                month: localData.month,
                year: localData.year
            })
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <>
                {/* Filter & Refresh */}
                <div className="flex justify-between pb-10">
                    <div className="flex-initial w-3/12">
                        <FilterDashboard
                            userCategory={this.state.userCategory}
                            dataCSName={this.state.listCustomerServiceData}
                            handleFilter={this.handleFilter}
                            handleResetFilter={this.handleResetFilter}
                            month={this.state.month}
                            year={this.state.year}
                            csId={this.state.listCustomerServiceId}
                        />
                    </div>
                    <div id="btnrefresh" className={this.state.loading ? "flex flex-initial select-none px-7 py-1 justify-center items-center rounded bg-nexcaredefault text-white shadow-box-button text-lg cursor-not-allowed" : "flex flex-initial select-none px-7 py-1 justify-center items-center rounded bg-nexcaredefault text-white shadow-box-button text-lg cursor-pointer"} onClick={this.handleRefresh}>
                        <IconUpdate />
                        <div className="ml-1">Perbaharui</div>
                    </div>
                </div>

                {/* Warning Alert */}
                <DashboardWarningAlert show={this.state.showDashboardWarningAlert} />

                {/* Dashboard Card Component */}
                <div className="grid grid-cols-7 gap-4 pb-10">
                    <TicketBoxListAll loading={this.state.loading} handlePopupTicketBox={this.handlePopupTicketBox} handlePopupCsOnline={this.handlePopupCsOnline} data={this.state.ticketBoxData} totalOnline={this.state.totalOnline} />
                    <TicketEscalationList loading={this.state.loading} data={this.state.escalationData} />
                    <TicketBoxListSolution loading={this.state.loading} handlePopupTicketBox={this.handlePopupTicketBox} data={this.state.ticketBoxData} />
                    <TicketOverviewChart loading={this.state.loading} data={this.state.ticketOverviewData} detail={this.state.ticketOverviewDataDetail} handlePopupTicketOverview={this.handlePopupTicketOverview} />
                    <TicketCompletionChart loading={this.state.loading} handlePopupTicketResolution={this.handlePopupTicketResolution} data={this.state.completionData} />
                </div>

                {/* Popup Modal Ticket Box */}
                <div className={this.state.showPopupTicketBox ? "block" : "hidden"}>
                    <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className={`border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none min-w-min ${this.state.ticketBoxModalData.status === 'all' || this.state.ticketBoxModalData[0]?.status === 'unassign' ? 'w-1/4' : 'w-1/3'}`}>
                            <div className="body-attachment w-full flex rounded-lg flex-col p-8">
                                <div className="header flex justify-between text-center">
                                    <div className="text-nexcareblack1 text-2xl text-center font-medium w-full capitalize">{this.state.titleTicketBox}</div>
                                </div>
                                <div className="text-nexcareblack2 flex items-center flex-wrap my-5 max-h-40 overflow-auto">
                                    {this.ticketBoxModalDataComponent()}
                                </div>
                                <div className="flex items-center justify-center">
                                    <ButtonDarkBlue id="btnclose" onClick={() => this.setState({ titleTicketBox: "", showPopupTicketBox: false })}>Tutup</ButtonDarkBlue>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </div>

                {/* Popup Modal Cs Online */}
                <div className={this.state.showPopupCsOnline ? "block" : "hidden"}>
                    <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none min-w-min w-1/3">
                            <div className="body-attachment w-full flex rounded-lg flex-col p-8">
                                <div className="header flex justify-between text-center">
                                    <div className="text-nexcareblack1 text-2xl text-center font-medium w-full capitalize">CS Online</div>
                                </div>
                                <div className="text-nexcareblack2 flex items-center flex-wrap my-5 max-h-40 overflow-auto">
                                    {
                                        this.state.totalOnline.length > 0
                                            ? this.state.totalOnline.map((data, idx) =>
                                                <div className={`flex items-center justify-between w-1/2 pb-2 ${idx % 2 === 0 ? 'pr-3' : 'pl-3 pr-1'}`} key={idx}>
                                                    <p className="whitespace-nowrap">{data.name}</p>
                                                </div>
                                            )
                                            : <div className="flex justify-center items-center w-full h-40">
                                                <p>Tidak ada data</p>
                                            </div>
                                    }
                                </div>
                                <div className="flex items-center justify-center">
                                    <ButtonDarkBlue id="btnclose" onClick={() => this.setState({ titleTicketBox: "", showPopupCsOnline: false })}>Tutup</ButtonDarkBlue>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </div>

                {/* Popup Modal Ticket By Resolution Time */}
                <div className={this.state.showPopupTicketByResolution ? "block" : "hidden"}>
                    <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none w-3/4 min-w-min">
                            <div className="body-attachment w-full flex rounded-lg flex-col p-8 text-nexcareblue1 font-bold text-lg">
                                <div className="header flex justify-between pb-5">
                                    <div className="text-2xl capitalize">Tiket berdasarkan Waktu Resolusi</div>
                                </div>
                                <div>
                                    <TableNexcare
                                        column={columnsCompletionDetail}
                                        dataTable={this.state.completionDataDetail}
                                        pagination={false}
                                        onPage={this.handleSelectedPage}
                                        onPageSize={this.handleSelectedPageSize}
                                        onSorter={this.handleSorter}
                                    />
                                    <div className="flex items-center justify-center mt-3">
                                        <ButtonDarkBlue id="btnclose" onClick={() => this.setState({ showPopupTicketByResolution: false })}>Tutup</ButtonDarkBlue>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardLead);